const OBJECT_ID_PATTERN = /^[0-9a-fA-F]{24}$/;
const UUID_PATTERN = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

type RelatedRecordLike = {
  module?: unknown;
  display_label?: unknown;
  entity_name?: unknown;
  name?: unknown;
  display_id?: unknown;
  public_id?: unknown;
  formatted_id?: unknown;
  entity_id?: unknown;
  id?: unknown;
};

export const TECHNICAL_IDENTIFIER_FALLBACK = 'Reference hidden';

export function cleanDisplayText(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function isObjectIdLike(value: unknown): boolean {
  return OBJECT_ID_PATTERN.test(cleanDisplayText(value));
}

export function isUuidLike(value: unknown): boolean {
  return UUID_PATTERN.test(cleanDisplayText(value));
}

export function isTechnicalIdentifierLike(value: unknown): boolean {
  const text = cleanDisplayText(value);
  return OBJECT_ID_PATTERN.test(text) || UUID_PATTERN.test(text);
}

export function getSafeDisplayText(value: unknown, fallback = TECHNICAL_IDENTIFIER_FALLBACK): string {
  const text = cleanDisplayText(value);
  if (!text) return '';
  return isTechnicalIdentifierLike(text) ? fallback : text;
}

export function getSafeRelatedRecordLabel(
  record: RelatedRecordLike | null | undefined,
  fallback = TECHNICAL_IDENTIFIER_FALLBACK,
): string {
  if (!record) return fallback;

  const candidates = [
    record.display_label,
    record.entity_name,
    record.name,
    record.display_id,
    record.public_id,
    record.formatted_id,
    record.entity_id,
    record.id,
  ];

  for (const candidate of candidates) {
    const label = getSafeDisplayText(candidate, '');
    if (label) return label;
  }

  return fallback;
}
